import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AuthService} from "./auth.service";

@Injectable()
export class  AuthGuard implements CanActivate{

  constructor(private authservice:AuthService,private router: Router){}


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {

    return this.authservice.authorized$
      .map(resp => resp)
      .take(1)
      .do(
        allowed => {

          // console.log('Alloed');
          // console.log(allowed);

          if(allowed == null){
            this.authservice.logout();
            this.router.navigate(['/login']);
          }
          // if ()
        } )

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/security/auth-guard.ts